







































import Vue from 'vue';
import { mapGetters } from 'vuex';
import ProductEditSection from '@/web/components/products/ProductEditSection.vue';

export default Vue.extend({
  name: 'ProductDetails',
  components: {
    ProductEditSection,
  },
  computed: {
    ...mapGetters({
      productForm: 'product/productForm',
    }),
    productName: {
      get() {
        return this.productForm.product_name;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', { product_name: value });
      },
    },
    thumbnailFile: {
      get(): PhotoResponse {
        return this.productForm.thumbnail_file;
      },
      set(value: PhotoResponse): void {
        this.$store.dispatch('product/setProductForm', {
          thumbnail_file: value,
        });
      },
    },
    productDescription: {
      get() {
        return this.productForm.product_description;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description: value,
        });
      },
    },
    productDescriptionNew: {
      get(): string {
        return this.productForm.product_description_new;
      },
      set(value: string) {
        this.$store.dispatch('product/setProductForm', {
          product_description_new: value,
        });
      },
    },
  },
});
